"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortedSpecialEffectLighting = exports.SPECIAL_EFFECT_LIGHTING_IDS = exports.LIGHT_TWO = exports.LIGHT_THREE = exports.LIGHT_ONE = exports.LIGHT_FOUR = void 0;
var _lightStyles = require("./lightStyles");
var _functions = require("../utility/functions");
var _helpers = require("./helpers");
const LIGHT_ONE = exports.LIGHT_ONE = 'LIGHT_ONE';
const LIGHT_TWO = exports.LIGHT_TWO = 'LIGHT_TWO';
const LIGHT_THREE = exports.LIGHT_THREE = 'LIGHT_THREE';
const LIGHT_FOUR = exports.LIGHT_FOUR = 'LIGHT_FOUR';
const SPECIAL_EFFECT_LIGHTING_IDS = exports.SPECIAL_EFFECT_LIGHTING_IDS = {
  BEEP_HIGH: 'BEEP_HIGH',
  CAUGHT: 'CAUGHT',
  COMPUTER_STARTUP: 'COMPUTER_STARTUP',
  LONG_EXPLOSION: 'LONG_EXPLOSION',
  EXPLOSION_CUT_OFF: 'EXPLOSION_CUT_OFF',
  EXPLOSION: 'EXPLOSION',
  FLICKER: 'FLICKER',
  PHASER_CANNON: 'PHASER_CANNON',
  POWER_DOWN: 'POWER_DOWN',
  POWER_UP: 'POWER_UP',
  PROBE: 'PROBE',
  SCANNER: 'SCANNER',
  SHIP_PASS_BY: 'SHIP_PASS_BY',
  TORPEDO: 'TORPEDO',
  TRACTOR_BEAM: 'TRACTOR_BEAM',
  TRANSPORT: 'TRANSPORT',
  WARP_JUMP: 'WARP_JUMP',
  WARP_STOP: 'WARP_STOP',
  CHRISTMAS: 'CHRISTMAS',
  DEEP_RED_ALERT: 'DEEP_RED_ALERT',
  RED_ALERT: 'RED_ALERT',
  CULMINATING_MOMENT_START: 'CULMINATING_MOMENT_START',
  CULMINATING_MOMENT_DELIBERATION: 'CULMINATING_MOMENT_DELIBERATION',
  CULMINATING_MOMENT_TEACHER_CHOICE: 'CULMINATING_MOMENT_TEACHER_CHOICE'
};
const LIGHTS = [LIGHT_ONE, LIGHT_TWO, LIGHT_THREE, LIGHT_FOUR];
const specialEffectLighting = {
  [SPECIAL_EFFECT_LIGHTING_IDS.BEEP_HIGH]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE
    }, {
      delay: 140,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 280,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 420,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 560,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 840,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.CULMINATING_MOMENT_START]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM
    }, {
      delay: 500,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 1000,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 1000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 1500,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 1500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW
    }, {
      delay: 11000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_CHANGE
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.CULMINATING_MOMENT_DELIBERATION]: createCulminatingMomentDeliberationLighting(),
  [SPECIAL_EFFECT_LIGHTING_IDS.CULMINATING_MOMENT_TEACHER_CHOICE]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE
    }, {
      delay: 500,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 900,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 900,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW
    }, {
      delay: 30000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_CHANGE
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.CAUGHT]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: 300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.COMPUTER_STARTUP]: {
    lightEffects: [{
      delay: 750,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE,
      lights: [LIGHT_ONE]
    }, {
      delay: 1400,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE,
      lights: [LIGHT_TWO]
    }, {
      delay: 2150,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE,
      lights: [LIGHT_THREE]
    }, {
      delay: 2600,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE,
      lights: [LIGHT_FOUR]
    }, {
      delay: 2800,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_FOUR]
    }, {
      delay: 3000,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_THREE]
    }, {
      delay: 3200,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_TWO]
    }, {
      delay: 3400,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_ONE]
    }, {
      delay: 3600,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_ONE]
    }, {
      delay: 3800,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_TWO]
    }, {
      delay: 4000,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_THREE]
    }, {
      delay: 4200,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_FOUR]
    }, {
      delay: 4400,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_FOUR]
    }, {
      delay: 4600,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_THREE]
    }, {
      delay: 4800,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_TWO]
    }, {
      delay: 5000,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_ONE]
    }, {
      delay: 5200,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_ONE]
    }, {
      delay: 5400,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_TWO]
    }, {
      delay: 5600,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_THREE]
    }, {
      delay: 5800,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_FOUR]
    }, {
      delay: 6000,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT_FAST
    }, {
      delay: 6600,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT_VERY_LOW
    }, {
      delay: 8500,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_IN_FAST
    }, {
      delay: 9000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.LONG_EXPLOSION]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.RED
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT_MEDIUM
    }, {
      delay: 2750,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 2800,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST,
      lights: [LIGHT_FOUR]
    }, {
      delay: 2800,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE,
      lights: [LIGHT_ONE, LIGHT_TWO]
    }, {
      delay: 3000,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_THREE]
    }, {
      delay: 3100,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 3200,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_THREE]
    }, {
      delay: 3300,
      style: _lightStyles.LIGHT_STYLE_IDS.RED,
      lights: [LIGHT_THREE]
    }, {
      delay: 3350,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_THREE]
    }, {
      delay: 3450,
      style: _lightStyles.LIGHT_STYLE_IDS.RED,
      lights: [LIGHT_THREE]
    }, {
      delay: 3600,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST
    }, {
      delay: 3800,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 3900,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT,
      lights: [LIGHT_THREE, LIGHT_FOUR]
    }, {
      delay: 4200,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO]
    }, {
      delay: 4300,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE,
      lights: [LIGHT_THREE, LIGHT_FOUR]
    }, {
      delay: 4300,
      style: _lightStyles.LIGHT_STYLE_IDS.RED,
      lights: [LIGHT_TWO]
    }, {
      delay: 4350,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO]
    }, {
      delay: 4450,
      style: _lightStyles.LIGHT_STYLE_IDS.RED,
      lights: [LIGHT_TWO]
    }, {
      delay: 5000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 6000,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6100,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6300,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6350,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6700,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6800,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6850,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6900,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6950,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 7000,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_ONE]
    }, {
      delay: 6100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_THREE]
    }, {
      delay: 6200,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 6300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 6400,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_ONE]
    }, {
      delay: 6500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_THREE]
    }, {
      delay: 6600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 6700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 7000,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE
    }, {
      delay: 7100,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE
    }, {
      delay: 7100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW
    }, {
      delay: 7500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: 7700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_TWO]
    }, {
      delay: 7800,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: 8000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_TWO]
    }, {
      delay: 7300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7350,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7800,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7900,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7950,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 7650,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_THREE]
    }, {
      delay: 7700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 7750,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_THREE]
    }, {
      delay: 7100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 7300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 7400,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 7500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 7700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 7750,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 8000,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE
    }, {
      delay: 9000,
      style: _lightStyles.LIGHT_STYLE_IDS.RED
    }, {
      delay: 9500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: 9700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_TWO]
    }, {
      delay: 9800,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: 10000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_TWO]
    }, {
      delay: 9300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9350,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9800,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9900,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9950,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 9650,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_THREE]
    }, {
      delay: 9700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 9750,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_THREE]
    }, {
      delay: 9100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 9300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 9400,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 9500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 9700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 9750,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 10000,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_IN_FAST
    }, {
      delay: 10500,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 11000,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_ONE, LIGHT_TWO]
    }, {
      delay: 11100,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_ONE, LIGHT_TWO]
    }, {
      delay: 11300,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_THREE, LIGHT_FOUR]
    }, {
      delay: 11350,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_THREE, LIGHT_FOUR]
    }, {
      delay: 11600,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 11800,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 11700,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 12100,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 12600,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: 12800,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: 12700,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: 13100,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: 13500,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT_MEDIUM
    }, {
      delay: 14000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT_LOW
    }, {
      delay: 14300,
      style: _lightStyles.LIGHT_STYLE_IDS.RED_LOW
    }, {
      delay: 14700,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_IN
    }, {
      delay: 14999,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 15000,
      style: _lightStyles.LIGHT_STYLE_IDS.RED
    }, {
      delay: 17000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 17020,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.EXPLOSION_CUT_OFF]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.RED
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT_MEDIUM
    }, {
      delay: 2750,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 2800,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST,
      lights: [LIGHT_FOUR]
    }, {
      delay: 2800,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE,
      lights: [LIGHT_ONE, LIGHT_TWO]
    }, {
      delay: 3000,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_THREE]
    }, {
      delay: 3100,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 3200,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_THREE]
    }, {
      delay: 3300,
      style: _lightStyles.LIGHT_STYLE_IDS.RED,
      lights: [LIGHT_THREE]
    }, {
      delay: 3350,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_THREE]
    }, {
      delay: 3450,
      style: _lightStyles.LIGHT_STYLE_IDS.RED,
      lights: [LIGHT_THREE]
    }, {
      delay: 3600,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST
    }, {
      delay: 3800,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 3900,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT,
      lights: [LIGHT_THREE, LIGHT_FOUR]
    }, {
      delay: 4200,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO]
    }, {
      delay: 4300,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE,
      lights: [LIGHT_THREE, LIGHT_FOUR]
    }, {
      delay: 4300,
      style: _lightStyles.LIGHT_STYLE_IDS.RED,
      lights: [LIGHT_TWO]
    }, {
      delay: 4350,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO]
    }, {
      delay: 4450,
      style: _lightStyles.LIGHT_STYLE_IDS.RED,
      lights: [LIGHT_TWO]
    }, {
      delay: 5000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 6000,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6100,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6300,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6350,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6700,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6800,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6850,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6900,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6950,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 7000,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 6000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_ONE]
    }, {
      delay: 6100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_THREE]
    }, {
      delay: 6200,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 6300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 6400,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_ONE]
    }, {
      delay: 6500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_THREE]
    }, {
      delay: 6600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 6700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 7000,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE
    }, {
      delay: 7100,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE
    }, {
      delay: 7100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW
    }, {
      delay: 7500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: 7700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_TWO]
    }, {
      delay: 7800,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: 8000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_TWO]
    }, {
      delay: 7300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7350,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7800,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7900,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7950,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 7600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 7650,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_THREE]
    }, {
      delay: 7700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 7750,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_THREE]
    }, {
      delay: 7100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 7300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 7400,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 7500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 7700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 7750,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 8000,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE
    }, {
      delay: 9000,
      style: _lightStyles.LIGHT_STYLE_IDS.RED
    }, {
      delay: 9500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: 9700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_TWO]
    }, {
      delay: 9800,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: 10000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_TWO]
    }, {
      delay: 9300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9350,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9800,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9900,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9950,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_FOUR]
    }, {
      delay: 9600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 9650,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_THREE]
    }, {
      delay: 9700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 9750,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_THREE]
    }, {
      delay: 9100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 9300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 9400,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 9500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 9700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 9750,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
      lights: [LIGHT_ONE]
    }, {
      delay: 10000,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_IN_FAST
    }, {
      delay: 10500,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 11000,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_ONE, LIGHT_TWO]
    }, {
      delay: 11100,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_ONE, LIGHT_TWO]
    }, {
      delay: 11300,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_THREE, LIGHT_FOUR]
    }, {
      delay: 11350,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_THREE, LIGHT_FOUR]
    }, {
      delay: 11600,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 11800,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 11700,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 12100,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 12600,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: 12800,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: 12700,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: 13100,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: 13500,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT_MEDIUM
    }, {
      delay: 14000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT_LOW
    }, {
      delay: 14300,
      style: _lightStyles.LIGHT_STYLE_IDS.RED_LOW
    }, {
      delay: 14700,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_IN
    }, {
      delay: 14999,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 15000,
      style: _lightStyles.LIGHT_STYLE_IDS.RED
    }, {
      delay: 17000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 17020,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.EXPLOSION]: {
    lightEffects: [{
      delay: 100,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO]
    }, {
      delay: 150,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_TWO]
    }, {
      delay: 150,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_FOUR]
    }, {
      delay: 200,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_FOUR]
    }, {
      delay: 300,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_ONE]
    }, {
      delay: 400,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_ONE]
    }, {
      delay: 400,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_THREE]
    }, {
      delay: 475,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE,
      lights: [LIGHT_THREE]
    }, {
      delay: 500,
      style: _lightStyles.LIGHT_STYLE_IDS.RED_LOW
    }, {
      delay: 1000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.FLICKER]: {
    lightEffects: [...(0, _helpers.getFlicker)(700), ...(0, _helpers.getFlicker)(900, _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM), ...(0, _helpers.getFlicker)(1500, _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP), ...(0, _helpers.getFlicker)(1700, _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM), ...(0, _helpers.getFlicker)(2000), ...(0, _helpers.getFlicker)(3100, _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW), ...(0, _helpers.getFlicker)(3400, _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP), ...(0, _helpers.getFlicker)(3700), ...(0, _helpers.getFlicker)(4500, _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM), {
      delay: 4800,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.PHASER_CANNON]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP
    }, {
      delay: 100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: 200,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP
    }, {
      delay: 300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: 400,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP
    }, {
      delay: 500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: 600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP
    }, {
      delay: 700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: 800,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP
    }, {
      delay: 900,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: 1000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP
    }, {
      delay: 1100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: 1200,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP
    }, {
      delay: 1300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.POWER_DOWN]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 1,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT_FAST
    }, {
      delay: 650,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT_VERY_LOW
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.POWER_UP]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 1,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_IN_FAST
    }, {
      delay: 650,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.PROBE]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP
    }, {
      delay: 500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.SCANNER]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST,
      lights: [LIGHT_ONE]
    }, {
      delay: 400,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST,
      lights: [LIGHT_TWO]
    }, {
      delay: 800,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST,
      lights: [LIGHT_THREE]
    }, {
      delay: 1200,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST,
      lights: [LIGHT_FOUR]
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.SHIP_PASS_BY]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    },
    // Light 1
    {
      delay: _helpers.PASS_BY_LENGTH,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_ONE]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_ONE]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 1000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_ONE]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 1500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    },
    // Light 2
    {
      delay: _helpers.PASS_BY_LENGTH + 1000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_TWO]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 1500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_TWO]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 2000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_TWO]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 2500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    },
    // Light 3
    {
      delay: _helpers.PASS_BY_LENGTH + 2000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_THREE]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 2500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_THREE]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 3000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_THREE]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 3500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    },
    // Light 4
    {
      delay: _helpers.PASS_BY_LENGTH + 3000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_FOUR]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 3500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 4000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP,
      lights: [LIGHT_FOUR]
    }, {
      delay: _helpers.PASS_BY_LENGTH + 4500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_FOUR]
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.TORPEDO]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP
    }, {
      delay: 500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.TRACTOR_BEAM]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: 300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.TRANSPORT]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: 300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM
    }, {
      delay: 600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: 900,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM
    }, {
      delay: 1200,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.WARP_JUMP]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.NONE
    }, {
      delay: 1,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    },
    // Lights 1 & 4 pulse
    {
      delay: 1,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT_MEDIUM,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: 3400,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT_VERY_LOW,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT_LOW,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 100,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 300,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 400,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 600,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 700,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 800,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 900,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 1100,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 1200,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 1400,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 1500,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 1700,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 1800,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 2000,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    }, {
      delay: _helpers.WARP_PULSE + 2100,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_ONE, LIGHT_FOUR]
    },
    // Lights 2 & 3 pulse
    {
      delay: 5000,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT_MEDIUM,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: 8400,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT_VERY_LOW,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT_LOW,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 100,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 200,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 400,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 500,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 700,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 800,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 900,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 1000,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_GREEN,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 1200,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 1300,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 1500,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 1600,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 1800,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 1900,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 2100,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED,
      lights: [LIGHT_TWO, LIGHT_THREE]
    }, {
      delay: _helpers.WARP_PULSE + 2200,
      style: _lightStyles.LIGHT_STYLE_IDS.SUB_RED,
      lights: [LIGHT_TWO, LIGHT_THREE]
    },
    // PEAK
    {
      delay: _helpers.WARP_PULSE + 2300,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: _helpers.WARP_PULSE + 2300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }, {
      delay: _helpers.WARP_PULSE + 2300,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_GREEN
    }, {
      delay: _helpers.WARP_PULSE + 2300,
      style: _lightStyles.LIGHT_STYLE_IDS.ADD_RED
    }, {
      delay: _helpers.WARP_PULSE + 2499,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    },
    // ENERGY REGEN
    {
      delay: _helpers.WARP_PULSE + 2500,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_IN_SLOW
    }, {
      delay: _helpers.WARP_PULSE + 15000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: _helpers.WARP_PULSE + 15000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    },
    // WARP FIELD STABILIZE
    {
      delay: _helpers.WARP_PULSE + 23500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_BLIP
    }, {
      delay: _helpers.WARP_PULSE + 24500,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.WARP_STOP]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BLUE
    }, {
      delay: 1,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_OUT_MEDIUM
    }, {
      delay: 3500,
      style: _lightStyles.LIGHT_STYLE_IDS.FADE_IN_MEDIUM
    }, {
      delay: 6800,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_EFFECT
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.CHRISTMAS]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.RED,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.WHITE,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 800,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.DEEP_RED_ALERT]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.AMBIANCE_RED
    },
    // Light 1
    {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: 300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_ONE]
    }, {
      delay: 2100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    },
    // Light 2
    {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: 600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_TWO]
    }, {
      delay: 2400,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    },
    // Light 3
    {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: 900,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_THREE]
    }, {
      delay: 2700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    },
    // Light 4
    {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_FOUR]
    }, {
      delay: 1200,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: 3000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_FOUR]
    },
    // Loop 2
    {
      delay: _helpers.DEEP_RED_ALERT_LOOP_2 + 300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_ONE]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_2 + 600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_TWO]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_2 + 900,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_THREE]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_2 + 1200,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_2 + 2100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_2 + 2400,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_2 + 2700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_2 + 3000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_FOUR]
    },
    // Loop 3
    {
      delay: _helpers.DEEP_RED_ALERT_LOOP_3 + 300,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_ONE]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_3 + 600,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_TWO]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_3 + 900,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_THREE]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_3 + 1200,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
      lights: [LIGHT_FOUR]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_3 + 2100,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_ONE]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_3 + 2400,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_TWO]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_3 + 2700,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_THREE]
    }, {
      delay: _helpers.DEEP_RED_ALERT_LOOP_3 + 3000,
      style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_HIGH,
      lights: [LIGHT_FOUR]
    }]
  },
  [SPECIAL_EFFECT_LIGHTING_IDS.RED_ALERT]: {
    lightEffects: [{
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.PASSIVE_RED
    }, {
      delay: 0,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST,
      lights: [LIGHT_ONE, LIGHT_THREE]
    }, {
      delay: 800,
      style: _lightStyles.LIGHT_STYLE_IDS.PULSE_FAST,
      lights: [LIGHT_TWO, LIGHT_FOUR]
    }, {
      delay: 2000,
      style: _lightStyles.LIGHT_STYLE_IDS.NO_CHANGE,
      lights: []
    }]
  }
};
const sortedSpecialEffectLighting = exports.sortedSpecialEffectLighting = {};

// Cast to string and then back to special effect lighting id because flow for forEachEntry doesn't
// recognize literal key values
(0, _functions.forEachEntry)(specialEffectLighting, ([id, lightEffectInfo]) => {
  lightEffectInfo.lightEffects = lightEffectInfo.lightEffects.sort((a, b) => a.delay <= b.delay ? -1 : 1);
  sortedSpecialEffectLighting[id] = lightEffectInfo;
});
function createCulminatingMomentDeliberationLighting() {
  const lighting = [{
    delay: 0,
    style: _lightStyles.LIGHT_STYLE_IDS.BLUE
  }, {
    delay: 0,
    style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW
  }];
  const SOUND_LENGTH = 200000; // just over 3 minutes
  let delay = 0;
  while (delay < SOUND_LENGTH) {
    for (let i = 0; i < LIGHTS.length; i++) {
      lighting.push({
        delay,
        style: _lightStyles.LIGHT_STYLE_IDS.BLUE,
        lights: [LIGHTS[i]]
      });
      lighting.push({
        delay,
        style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_MEDIUM,
        lights: [LIGHTS[i]]
      });
      lighting.push({
        delay: delay + 400,
        style: _lightStyles.LIGHT_STYLE_IDS.BRIGHTNESS_LOW,
        lights: [LIGHTS[i]]
      });
      delay += 2000;
    }
  }
  return {
    lightEffects: lighting
  };
}